import type { ProjectType } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { getNextgenSettingsUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';

export const createProjectUrl = (projectKey: string) => `/browse/${encodeURIComponent(projectKey)}`;

export const createProjectSettingsUrl = (
	projectKey: string,
	projectType: ProjectType,
	isSimplified: boolean,
) => {
	if (isSimplified) {
		return getNextgenSettingsUrl(projectType, projectKey);
	}
	return `/projects/${projectKey}/settings`;
};

export const createBoardUrl = (boardId: number) => `/secure/RapidBoard.jspa?rapidView=${boardId}`;
